import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/external-authentication/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.featureFlags[FeatureFlags.ExternalVaults] &&
      context.userPermissions.hasAllowedPermission({
        path: PAGE_PATHS.EXTERNAL_AUTHENTICATION,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
